import React from "react";

const OpenTextQuestion = ({ question, value, onChange }) => {
  const {
    questionId,
    maxLength = 1000,
    placeholder = "Type your response here...",
  } = question;

  const text = value || "";

  return (
    <div>
      <textarea
        value={text}
        onChange={(e) => onChange(questionId, e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={4}
        className="w-full spiders-input resize-none"
      />
      <div className="flex justify-end text-xs text-spiders-text-muted mt-1">
        <span>
          {text.length}/{maxLength}
        </span>
      </div>
    </div>
  );
};

export default OpenTextQuestion;
